module.exports = __webpack_public_path__ + "img/arrow-left.a53aa3c2.svg";